import { lazy } from 'react';

export default [
  {
    title: 'Home Page',
    component: lazy(() => import('./Home')),
    url: '/external',
    requirePermission: false,
  },
];
